/* eslint-disable */
import axios from "axios";
const button = document.querySelector('.load-more');
if (typeof button !== 'undefined' && button !== null) {
  button.addEventListener('click', e => {
    let current_page = document.querySelector('.dealer-list').dataset.page;
    let max_pages = document.querySelector('.dealer-list').dataset.max;
    let params = new URLSearchParams();
    params.append('action', 'load_more_posts');
    params.append('current_page', current_page);
    params.append('max_pages', max_pages);
    axios.post('/wp-admin/admin-ajax.php', params).then(res => {
      let posts_list = document.querySelector('.dealer-list');
      posts_list.innerHTML += res.data.data;
      document.querySelector('.dealer-list').dataset.page++;
      if (document.querySelector('.dealer-list').dataset.page == document.querySelector('.dealer-list').dataset.max) {
        button.parentNode.removeChild(button);
      }
    });
  });
}